<template>
  <section  class="pt-4 mb-4">
    <div v-if="support && !isLoading">
      <section-title>
        {{ support.title }}
      </section-title>
      <b-card>
        <b-img
          class="support-img"
          center
          :src="support.image"
          v-if="support.image"
        />
        <div class="display-content" v-if="support.text" v-html="support.text"></div>
        <div class="d-flex flex-column">
           <div class="mb-2">   
            <b-button
          class="float-right" 
          :href="'tel:' + support.telephone"
          variant="outline-primary"
          size="sm"
          v-if="support.telephone"
        >
          <svgicon
            icon="phone"
            class="mr-1"
            width="15"
            height="15"
          />
          <strong>{{ support.telephone | formatPhone }}</strong>
        </b-button></div>
           <div class="mb-2">   
            <b-button
           class="float-right" 
          variant="outline-primary"
          size="sm"
          @click="onClickExternalBtn(support.externalButtonUrl)"
          v-if="support.externalButtonLabel && support.externalButtonUrl"
          >
         
          <strong>{{ support.externalButtonLabel ? support.externalButtonLabel : '' }}</strong>
        </b-button></div>
          <div>   
          <b-button
          @click="onClickInternalBtn(support.internalButtonUrlWeb)"
          class="float-right" 
          variant="outline-primary"
          size="sm"
          v-if="support.internalButtonUrlWeb && support.internalButtonLabel"
        >
          
          <strong>{{ support.internalButtonLabel ? support.internalButtonLabel : '' }}</strong>
        </b-button>
        </div>
        </div>
       
           
      </b-card>
    </div>
    <b-card
      class="mb-3"
      v-else-if="!isLoading"
    >
      <b-media class="text-center">
        {{ $t("no-data") }}
      </b-media>
    </b-card>

		<div v-if="isLoading" class="text-center">
			<b-spinner variant="primary" />
		</div>

  </section>
</template>

<script>
import SectionTitle from "@/components/SectionTitle/SectionTitle.vue"
import { mapActions, mapGetters } from 'vuex'
import { KEYWORDS } from "../../constants/support";
import Utils from "@/mixins/Utils";
import { isNavigationFailure, NavigationFailureType } from 'vue-router'


export default {
  components: {
    SectionTitle,
  },
  mixins: [Utils],
  computed: {
    ...mapGetters('psySocialSupport', ['psySupport', 'socialSupport']),
    ...mapGetters(['isLoading']),
    keyword() {
      return this.$route.params.keyword
    },
    support() {
      switch (this.keyword) {
        case KEYWORDS.PSYCHOLOGIC:
          return this.psySupport;
        case KEYWORDS.SOCIAL:
          return this.socialSupport;
        default:
          return null
      }
    }
  },
  watch: {
    keyword(val) {
      this.getSupport(val);
    }
  },
  created() {
    this.getSupport(this.keyword);
  },
  methods: {
    ...mapActions('psySocialSupport', ['getSupport']),
     onClickInternalBtn(value) {
       if(value && value!=='') {
       let screenName = JSON.parse(value);
       this.onCheckreDirectInternal(screenName.screenName)
       }
         
    },
     onCheckreDirectInternal(name) {
    const link = this.$router.resolve({
    name: name,
    })

    if( link.resolved.matched.length > 0){
      this.$router.push({
        name: name
      })
    } else {
      this.callToaster(this.$t('internal-link-web-is-not-valid'));

    }

    },
    onClickExternalBtn(url) {
     if(url && url!=='') {
      if (!url.startsWith("https://") && url.indexOf('www') >=0) {
            url  = new URL("https://"+ url );
        }
      window.open(url, '_blank')
     }
    }
  }
}
</script>

<style lang="scss">
.display-content {
  iframe {
    max-width: 100%;
  }

  .image {
    display: table;
    clear: both;
    text-align: center;
    margin: 0.9em auto;
    min-width: 50px;
  }

  .image img {
    display: block;
    margin: 0 auto;
    max-width: 100%;
    min-width: 100%;
}

.media  {
    clear: both;
    margin: .9em 0;
    display: block;
    min-width: 15em;
}

}
</style>
<style scoped>
  .support-img {
    max-height: 250px;
    margin-bottom: 15px;
  }
  .display-content {
		white-space: pre-wrap;
    text-align: justify;
	}
</style>
